/* tslint:disable */
/* eslint-disable */
/**
 * 現場クラウド Arune API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "./configuration";
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
import type { RequestArgs } from "./base";
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from "./base";

/**
 *
 * @export
 * @interface CheckListsByResourceInner
 */
export interface CheckListsByResourceInner {
  /**
   *
   * @type {string}
   * @memberof CheckListsByResourceInner
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof CheckListsByResourceInner
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CheckListsByResourceInner
   */
  last_inspected_on?: string;
  /**
   *
   * @type {boolean}
   * @memberof CheckListsByResourceInner
   */
  selected: boolean;
}
/**
 *
 * @export
 * @interface CheckOverlapResourcePlansRequest
 */
export interface CheckOverlapResourcePlansRequest {
  /**
   *
   * @type {Array<ResourcePlanInput>}
   * @memberof CheckOverlapResourcePlansRequest
   */
  resourcePlans?: Array<ResourcePlanInput>;
}
/**
 *
 * @export
 * @interface CheckOverlapResultsInner
 */
export interface CheckOverlapResultsInner {
  /**
   *
   * @type {boolean}
   * @memberof CheckOverlapResultsInner
   */
  overlapped?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CheckOverlapResultsInner
   */
  editable?: boolean;
  /**
   *
   * @type {string}
   * @memberof CheckOverlapResultsInner
   */
  resourceId?: string;
  /**
   *
   * @type {string}
   * @memberof CheckOverlapResultsInner
   */
  resourceName?: string;
}
/**
 *
 * @export
 * @interface ConfirmInspectionQrCodesRequest
 */
export interface ConfirmInspectionQrCodesRequest {
  /**
   *
   * @type {string}
   * @memberof ConfirmInspectionQrCodesRequest
   */
  siteId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ConfirmInspectionQrCodesRequest
   */
  resourceIds: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ConfirmInspectionQrCodesRequest
   */
  checkListIds: Array<string>;
}
/**
 *
 * @export
 * @interface CreateResourcePlansRequest
 */
export interface CreateResourcePlansRequest {
  /**
   *
   * @type {string}
   * @memberof CreateResourcePlansRequest
   */
  siteId?: string;
  /**
   *
   * @type {string}
   * @memberof CreateResourcePlansRequest
   */
  resourceId?: string;
  /**
   *
   * @type {number}
   * @memberof CreateResourcePlansRequest
   */
  startedAt?: number;
  /**
   *
   * @type {number}
   * @memberof CreateResourcePlansRequest
   */
  endedAt?: number;
  /**
   *
   * @type {string}
   * @memberof CreateResourcePlansRequest
   */
  note?: string;
}
/**
 * 重機
 * @export
 * @interface HeavyMachine
 */
export interface HeavyMachine {
  /**
   *
   * @type {string}
   * @memberof HeavyMachine
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof HeavyMachine
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof HeavyMachine
   */
  groupName: string;
  /**
   *
   * @type {string}
   * @memberof HeavyMachine
   */
  subGroupName: string;
  /**
   *
   * @type {string}
   * @memberof HeavyMachine
   */
  subGroupIcon: string;
  /**
   *
   * @type {string}
   * @memberof HeavyMachine
   */
  color: string;
}
/**
 * 配置計画
 * @export
 * @interface HeavyMachinePlan
 */
export interface HeavyMachinePlan {
  /**
   *
   * @type {string}
   * @memberof HeavyMachinePlan
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof HeavyMachinePlan
   */
  startedAt: number;
  /**
   *
   * @type {number}
   * @memberof HeavyMachinePlan
   */
  endedAt: number;
  /**
   *
   * @type {HeavyMachine}
   * @memberof HeavyMachinePlan
   */
  heavyMachine: HeavyMachine;
  /**
   *
   * @type {Site}
   * @memberof HeavyMachinePlan
   */
  site: Site;
  /**
   *
   * @type {string}
   * @memberof HeavyMachinePlan
   */
  note: string;
}
/**
 *
 * @export
 * @interface HeavyMachineRunningTime
 */
export interface HeavyMachineRunningTime {
  /**
   *
   * @type {string}
   * @memberof HeavyMachineRunningTime
   */
  date: string;
  /**
   *
   * @type {number}
   * @memberof HeavyMachineRunningTime
   */
  time: number;
  /**
   *
   * @type {string}
   * @memberof HeavyMachineRunningTime
   */
  frequencyOfUse: string;
}
/**
 *
 * @export
 * @interface InspectionQrCodeConfirmation
 */
export interface InspectionQrCodeConfirmation {
  /**
   *
   * @type {string}
   * @memberof InspectionQrCodeConfirmation
   */
  message: string | null;
}
/**
 *
 * @export
 * @interface Resource
 */
export interface Resource {
  /**
   *
   * @type {string}
   * @memberof Resource
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Resource
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof Resource
   */
  groupName: string;
  /**
   *
   * @type {string}
   * @memberof Resource
   */
  subGroupName: string;
  /**
   *
   * @type {string}
   * @memberof Resource
   */
  color: string;
}
/**
 *
 * @export
 * @interface ResourcePlan
 */
export interface ResourcePlan {
  /**
   *
   * @type {string}
   * @memberof ResourcePlan
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ResourcePlan
   */
  siteId: string;
  /**
   *
   * @type {string}
   * @memberof ResourcePlan
   */
  resourceId: string;
  /**
   *
   * @type {number}
   * @memberof ResourcePlan
   */
  startedAt: number;
  /**
   *
   * @type {number}
   * @memberof ResourcePlan
   */
  endedAt: number;
  /**
   *
   * @type {string}
   * @memberof ResourcePlan
   */
  note: string;
  /**
   *
   * @type {Site}
   * @memberof ResourcePlan
   */
  site: Site;
  /**
   *
   * @type {Resource}
   * @memberof ResourcePlan
   */
  resource: Resource;
}
/**
 *
 * @export
 * @interface ResourcePlanInput
 */
export interface ResourcePlanInput {
  /**
   *
   * @type {string}
   * @memberof ResourcePlanInput
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ResourcePlanInput
   */
  siteId?: string;
  /**
   *
   * @type {string}
   * @memberof ResourcePlanInput
   */
  resourceId?: string;
  /**
   *
   * @type {number}
   * @memberof ResourcePlanInput
   */
  startedAt?: number;
  /**
   *
   * @type {number}
   * @memberof ResourcePlanInput
   */
  endedAt?: number;
  /**
   *
   * @type {string}
   * @memberof ResourcePlanInput
   */
  note?: string;
}
/**
 *
 * @export
 * @interface ResourceRunningTime
 */
export interface ResourceRunningTime {
  /**
   *
   * @type {string}
   * @memberof ResourceRunningTime
   */
  date: string;
  /**
   *
   * @type {number}
   * @memberof ResourceRunningTime
   */
  time: number;
  /**
   *
   * @type {string}
   * @memberof ResourceRunningTime
   */
  frequencyOfUse: string;
}
/**
 * 現場
 * @export
 * @interface Site
 */
export interface Site {
  /**
   *
   * @type {string}
   * @memberof Site
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Site
   */
  name: string;
}
/**
 *
 * @export
 * @interface SiteWithSchedule
 */
export interface SiteWithSchedule {
  /**
   *
   * @type {string}
   * @memberof SiteWithSchedule
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof SiteWithSchedule
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof SiteWithSchedule
   */
  startedDate: string;
  /**
   *
   * @type {string}
   * @memberof SiteWithSchedule
   */
  completedDate: string;
}
/**
 *
 * @export
 * @interface SiteWithScheduleAllOf
 */
export interface SiteWithScheduleAllOf {
  /**
   *
   * @type {string}
   * @memberof SiteWithScheduleAllOf
   */
  startedDate: string;
  /**
   *
   * @type {string}
   * @memberof SiteWithScheduleAllOf
   */
  completedDate: string;
}

/**
 * CheckListsApi - axios parameter creator
 * @export
 */
export const CheckListsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary 対象リソースを選択した際に点検簿リストを取得
     * @param {string} customerId 顧客ID
     * @param {string} resourceId リソースID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkListsByResource: async (
      customerId: string,
      resourceId: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'customerId' is not null or undefined
      assertParamExists("checkListsByResource", "customerId", customerId);
      // verify required parameter 'resourceId' is not null or undefined
      assertParamExists("checkListsByResource", "resourceId", resourceId);
      const localVarPath = `/{customerId}/api/v2/resources/{resourceId}/check_lists`
        .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
        .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CheckListsApi - functional programming interface
 * @export
 */
export const CheckListsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CheckListsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary 対象リソースを選択した際に点検簿リストを取得
     * @param {string} customerId 顧客ID
     * @param {string} resourceId リソースID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkListsByResource(
      customerId: string,
      resourceId: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Array<CheckListsByResourceInner>>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checkListsByResource(customerId, resourceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * CheckListsApi - factory interface
 * @export
 */
export const CheckListsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = CheckListsApiFp(configuration);
  return {
    /**
     *
     * @summary 対象リソースを選択した際に点検簿リストを取得
     * @param {string} customerId 顧客ID
     * @param {string} resourceId リソースID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkListsByResource(
      customerId: string,
      resourceId: string,
      options?: any,
    ): AxiosPromise<Array<Array<CheckListsByResourceInner>>> {
      return localVarFp.checkListsByResource(customerId, resourceId, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * CheckListsApi - object-oriented interface
 * @export
 * @class CheckListsApi
 * @extends {BaseAPI}
 */
export class CheckListsApi extends BaseAPI {
  /**
   *
   * @summary 対象リソースを選択した際に点検簿リストを取得
   * @param {string} customerId 顧客ID
   * @param {string} resourceId リソースID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CheckListsApi
   */
  public checkListsByResource(customerId: string, resourceId: string, options?: AxiosRequestConfig) {
    return CheckListsApiFp(this.configuration)
      .checkListsByResource(customerId, resourceId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * HeavyMachinePlansApi - axios parameter creator
 * @export
 */
export const HeavyMachinePlansApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 配置計画一覧を取得する
     * @summary 配置計画一覧
     * @param {string} [heavyMachineIdEq] 重機ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminAllHeavyMachinePlans: async (heavyMachineIdEq?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/xBj6IYX7qAnFG6EzwM103qB7MrYuNW/api/v1/heavy_machine_plans`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (heavyMachineIdEq !== undefined) {
        localVarQueryParameter["heavyMachineIdEq"] = heavyMachineIdEq;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * HeavyMachinePlansApi - functional programming interface
 * @export
 */
export const HeavyMachinePlansApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = HeavyMachinePlansApiAxiosParamCreator(configuration);
  return {
    /**
     * 配置計画一覧を取得する
     * @summary 配置計画一覧
     * @param {string} [heavyMachineIdEq] 重機ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminAllHeavyMachinePlans(
      heavyMachineIdEq?: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HeavyMachinePlan>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.adminAllHeavyMachinePlans(heavyMachineIdEq, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * HeavyMachinePlansApi - factory interface
 * @export
 */
export const HeavyMachinePlansApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = HeavyMachinePlansApiFp(configuration);
  return {
    /**
     * 配置計画一覧を取得する
     * @summary 配置計画一覧
     * @param {string} [heavyMachineIdEq] 重機ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminAllHeavyMachinePlans(heavyMachineIdEq?: string, options?: any): AxiosPromise<Array<HeavyMachinePlan>> {
      return localVarFp.adminAllHeavyMachinePlans(heavyMachineIdEq, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * HeavyMachinePlansApi - object-oriented interface
 * @export
 * @class HeavyMachinePlansApi
 * @extends {BaseAPI}
 */
export class HeavyMachinePlansApi extends BaseAPI {
  /**
   * 配置計画一覧を取得する
   * @summary 配置計画一覧
   * @param {string} [heavyMachineIdEq] 重機ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HeavyMachinePlansApi
   */
  public adminAllHeavyMachinePlans(heavyMachineIdEq?: string, options?: AxiosRequestConfig) {
    return HeavyMachinePlansApiFp(this.configuration)
      .adminAllHeavyMachinePlans(heavyMachineIdEq, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * HeavyMachinesApi - axios parameter creator
 * @export
 */
export const HeavyMachinesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 重機一覧を取得する
     * @summary 重機一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminAllHeavyMachines: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/xBj6IYX7qAnFG6EzwM103qB7MrYuNW/api/v1/heavy_machines`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * HeavyMachinesApi - functional programming interface
 * @export
 */
export const HeavyMachinesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = HeavyMachinesApiAxiosParamCreator(configuration);
  return {
    /**
     * 重機一覧を取得する
     * @summary 重機一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminAllHeavyMachines(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HeavyMachine>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.adminAllHeavyMachines(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * HeavyMachinesApi - factory interface
 * @export
 */
export const HeavyMachinesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = HeavyMachinesApiFp(configuration);
  return {
    /**
     * 重機一覧を取得する
     * @summary 重機一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminAllHeavyMachines(options?: any): AxiosPromise<Array<HeavyMachine>> {
      return localVarFp.adminAllHeavyMachines(options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * HeavyMachinesApi - object-oriented interface
 * @export
 * @class HeavyMachinesApi
 * @extends {BaseAPI}
 */
export class HeavyMachinesApi extends BaseAPI {
  /**
   * 重機一覧を取得する
   * @summary 重機一覧
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HeavyMachinesApi
   */
  public adminAllHeavyMachines(options?: AxiosRequestConfig) {
    return HeavyMachinesApiFp(this.configuration)
      .adminAllHeavyMachines(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * InspectionQrCodesApi - axios parameter creator
 * @export
 */
export const InspectionQrCodesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 点検用QRコード作成時に無効化される既存QRコードの有無を確認し、確認メッセージを取得する
     * @summary 点検用QRコード作成確認
     * @param {string} customerId 顧客ID
     * @param {ConfirmInspectionQrCodesRequest} [confirmInspectionQrCodesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmInspectionQrCodes: async (
      customerId: string,
      confirmInspectionQrCodesRequest?: ConfirmInspectionQrCodesRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'customerId' is not null or undefined
      assertParamExists("confirmInspectionQrCodes", "customerId", customerId);
      const localVarPath = `/{customerId}/api/v2/inspection_qr_codes/confirmation`.replace(
        `{${"customerId"}}`,
        encodeURIComponent(String(customerId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(confirmInspectionQrCodesRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * InspectionQrCodesApi - functional programming interface
 * @export
 */
export const InspectionQrCodesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = InspectionQrCodesApiAxiosParamCreator(configuration);
  return {
    /**
     * 点検用QRコード作成時に無効化される既存QRコードの有無を確認し、確認メッセージを取得する
     * @summary 点検用QRコード作成確認
     * @param {string} customerId 顧客ID
     * @param {ConfirmInspectionQrCodesRequest} [confirmInspectionQrCodesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async confirmInspectionQrCodes(
      customerId: string,
      confirmInspectionQrCodesRequest?: ConfirmInspectionQrCodesRequest,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InspectionQrCodeConfirmation>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.confirmInspectionQrCodes(
        customerId,
        confirmInspectionQrCodesRequest,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * InspectionQrCodesApi - factory interface
 * @export
 */
export const InspectionQrCodesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = InspectionQrCodesApiFp(configuration);
  return {
    /**
     * 点検用QRコード作成時に無効化される既存QRコードの有無を確認し、確認メッセージを取得する
     * @summary 点検用QRコード作成確認
     * @param {string} customerId 顧客ID
     * @param {ConfirmInspectionQrCodesRequest} [confirmInspectionQrCodesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmInspectionQrCodes(
      customerId: string,
      confirmInspectionQrCodesRequest?: ConfirmInspectionQrCodesRequest,
      options?: any,
    ): AxiosPromise<InspectionQrCodeConfirmation> {
      return localVarFp
        .confirmInspectionQrCodes(customerId, confirmInspectionQrCodesRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * InspectionQrCodesApi - object-oriented interface
 * @export
 * @class InspectionQrCodesApi
 * @extends {BaseAPI}
 */
export class InspectionQrCodesApi extends BaseAPI {
  /**
   * 点検用QRコード作成時に無効化される既存QRコードの有無を確認し、確認メッセージを取得する
   * @summary 点検用QRコード作成確認
   * @param {string} customerId 顧客ID
   * @param {ConfirmInspectionQrCodesRequest} [confirmInspectionQrCodesRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InspectionQrCodesApi
   */
  public confirmInspectionQrCodes(
    customerId: string,
    confirmInspectionQrCodesRequest?: ConfirmInspectionQrCodesRequest,
    options?: AxiosRequestConfig,
  ) {
    return InspectionQrCodesApiFp(this.configuration)
      .confirmInspectionQrCodes(customerId, confirmInspectionQrCodesRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ResourcePlansApi - axios parameter creator
 * @export
 */
export const ResourcePlansApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 配置計画一覧を取得する
     * @summary 配置計画一覧
     * @param {string} customerId 顧客ID
     * @param {string} startDate 開始日
     * @param {string} endDate 終了日
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allResourcePlansByPeriod: async (
      customerId: string,
      startDate: string,
      endDate: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'customerId' is not null or undefined
      assertParamExists("allResourcePlansByPeriod", "customerId", customerId);
      // verify required parameter 'startDate' is not null or undefined
      assertParamExists("allResourcePlansByPeriod", "startDate", startDate);
      // verify required parameter 'endDate' is not null or undefined
      assertParamExists("allResourcePlansByPeriod", "endDate", endDate);
      const localVarPath = `/{customerId}/api/v2/resource_plans`.replace(
        `{${"customerId"}}`,
        encodeURIComponent(String(customerId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startDate !== undefined) {
        localVarQueryParameter["startDate"] = startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter["endDate"] = endDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 配置計画重複チェック
     * @summary 配置計画重複チェック
     * @param {string} customerId 顧客ID
     * @param {CheckOverlapResourcePlansRequest} [checkOverlapResourcePlansRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkOverlapResourcePlans: async (
      customerId: string,
      checkOverlapResourcePlansRequest?: CheckOverlapResourcePlansRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'customerId' is not null or undefined
      assertParamExists("checkOverlapResourcePlans", "customerId", customerId);
      const localVarPath = `/{customerId}/api/v2/resource_plans/check_overlap`.replace(
        `{${"customerId"}}`,
        encodeURIComponent(String(customerId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        checkOverlapResourcePlansRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 配置計画重複登録
     * @summary 配置計画重複登録
     * @param {string} customerId 顧客ID
     * @param {CheckOverlapResourcePlansRequest} [checkOverlapResourcePlansRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createOverlapResourcePlans: async (
      customerId: string,
      checkOverlapResourcePlansRequest?: CheckOverlapResourcePlansRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'customerId' is not null or undefined
      assertParamExists("createOverlapResourcePlans", "customerId", customerId);
      const localVarPath = `/{customerId}/api/v2/resource_plans/create_overlap`.replace(
        `{${"customerId"}}`,
        encodeURIComponent(String(customerId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        checkOverlapResourcePlansRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 配置計画新規登録
     * @summary 配置計画新規登録
     * @param {string} customerId 顧客ID
     * @param {CreateResourcePlansRequest} [createResourcePlansRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createResourcePlans: async (
      customerId: string,
      createResourcePlansRequest?: CreateResourcePlansRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'customerId' is not null or undefined
      assertParamExists("createResourcePlans", "customerId", customerId);
      const localVarPath = `/{customerId}/api/v2/resource_plans`.replace(
        `{${"customerId"}}`,
        encodeURIComponent(String(customerId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(createResourcePlansRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 配置計画削除
     * @summary 配置計画削除
     * @param {string} customerId 顧客ID
     * @param {string} resourcePlanId 配置計画ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    destroyResourcePlans: async (
      customerId: string,
      resourcePlanId: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'customerId' is not null or undefined
      assertParamExists("destroyResourcePlans", "customerId", customerId);
      // verify required parameter 'resourcePlanId' is not null or undefined
      assertParamExists("destroyResourcePlans", "resourcePlanId", resourcePlanId);
      const localVarPath = `/{customerId}/api/v2/resource_plans/{resourcePlanId}`
        .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
        .replace(`{${"resourcePlanId"}}`, encodeURIComponent(String(resourcePlanId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 配置計画更新
     * @summary 配置計画更新
     * @param {string} customerId 顧客ID
     * @param {string} resourcePlanId 配置計画ID
     * @param {CreateResourcePlansRequest} [createResourcePlansRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateResourcePlans: async (
      customerId: string,
      resourcePlanId: string,
      createResourcePlansRequest?: CreateResourcePlansRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'customerId' is not null or undefined
      assertParamExists("updateResourcePlans", "customerId", customerId);
      // verify required parameter 'resourcePlanId' is not null or undefined
      assertParamExists("updateResourcePlans", "resourcePlanId", resourcePlanId);
      const localVarPath = `/{customerId}/api/v2/resource_plans/{resourcePlanId}`
        .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
        .replace(`{${"resourcePlanId"}}`, encodeURIComponent(String(resourcePlanId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(createResourcePlansRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ResourcePlansApi - functional programming interface
 * @export
 */
export const ResourcePlansApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ResourcePlansApiAxiosParamCreator(configuration);
  return {
    /**
     * 配置計画一覧を取得する
     * @summary 配置計画一覧
     * @param {string} customerId 顧客ID
     * @param {string} startDate 開始日
     * @param {string} endDate 終了日
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async allResourcePlansByPeriod(
      customerId: string,
      startDate: string,
      endDate: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ResourcePlan>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.allResourcePlansByPeriod(customerId, startDate, endDate, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * 配置計画重複チェック
     * @summary 配置計画重複チェック
     * @param {string} customerId 顧客ID
     * @param {CheckOverlapResourcePlansRequest} [checkOverlapResourcePlansRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkOverlapResourcePlans(
      customerId: string,
      checkOverlapResourcePlansRequest?: CheckOverlapResourcePlansRequest,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CheckOverlapResultsInner>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checkOverlapResourcePlans(
        customerId,
        checkOverlapResourcePlansRequest,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * 配置計画重複登録
     * @summary 配置計画重複登録
     * @param {string} customerId 顧客ID
     * @param {CheckOverlapResourcePlansRequest} [checkOverlapResourcePlansRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createOverlapResourcePlans(
      customerId: string,
      checkOverlapResourcePlansRequest?: CheckOverlapResourcePlansRequest,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ResourcePlan>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createOverlapResourcePlans(
        customerId,
        checkOverlapResourcePlansRequest,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * 配置計画新規登録
     * @summary 配置計画新規登録
     * @param {string} customerId 顧客ID
     * @param {CreateResourcePlansRequest} [createResourcePlansRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createResourcePlans(
      customerId: string,
      createResourcePlansRequest?: CreateResourcePlansRequest,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResourcePlan>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createResourcePlans(
        customerId,
        createResourcePlansRequest,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * 配置計画削除
     * @summary 配置計画削除
     * @param {string} customerId 顧客ID
     * @param {string} resourcePlanId 配置計画ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async destroyResourcePlans(
      customerId: string,
      resourcePlanId: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResourcePlan>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.destroyResourcePlans(customerId, resourcePlanId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * 配置計画更新
     * @summary 配置計画更新
     * @param {string} customerId 顧客ID
     * @param {string} resourcePlanId 配置計画ID
     * @param {CreateResourcePlansRequest} [createResourcePlansRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateResourcePlans(
      customerId: string,
      resourcePlanId: string,
      createResourcePlansRequest?: CreateResourcePlansRequest,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResourcePlan>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateResourcePlans(
        customerId,
        resourcePlanId,
        createResourcePlansRequest,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * ResourcePlansApi - factory interface
 * @export
 */
export const ResourcePlansApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ResourcePlansApiFp(configuration);
  return {
    /**
     * 配置計画一覧を取得する
     * @summary 配置計画一覧
     * @param {string} customerId 顧客ID
     * @param {string} startDate 開始日
     * @param {string} endDate 終了日
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allResourcePlansByPeriod(
      customerId: string,
      startDate: string,
      endDate: string,
      options?: any,
    ): AxiosPromise<Array<ResourcePlan>> {
      return localVarFp
        .allResourcePlansByPeriod(customerId, startDate, endDate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * 配置計画重複チェック
     * @summary 配置計画重複チェック
     * @param {string} customerId 顧客ID
     * @param {CheckOverlapResourcePlansRequest} [checkOverlapResourcePlansRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkOverlapResourcePlans(
      customerId: string,
      checkOverlapResourcePlansRequest?: CheckOverlapResourcePlansRequest,
      options?: any,
    ): AxiosPromise<Array<CheckOverlapResultsInner>> {
      return localVarFp
        .checkOverlapResourcePlans(customerId, checkOverlapResourcePlansRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * 配置計画重複登録
     * @summary 配置計画重複登録
     * @param {string} customerId 顧客ID
     * @param {CheckOverlapResourcePlansRequest} [checkOverlapResourcePlansRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createOverlapResourcePlans(
      customerId: string,
      checkOverlapResourcePlansRequest?: CheckOverlapResourcePlansRequest,
      options?: any,
    ): AxiosPromise<Array<ResourcePlan>> {
      return localVarFp
        .createOverlapResourcePlans(customerId, checkOverlapResourcePlansRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * 配置計画新規登録
     * @summary 配置計画新規登録
     * @param {string} customerId 顧客ID
     * @param {CreateResourcePlansRequest} [createResourcePlansRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createResourcePlans(
      customerId: string,
      createResourcePlansRequest?: CreateResourcePlansRequest,
      options?: any,
    ): AxiosPromise<ResourcePlan> {
      return localVarFp
        .createResourcePlans(customerId, createResourcePlansRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * 配置計画削除
     * @summary 配置計画削除
     * @param {string} customerId 顧客ID
     * @param {string} resourcePlanId 配置計画ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    destroyResourcePlans(customerId: string, resourcePlanId: string, options?: any): AxiosPromise<ResourcePlan> {
      return localVarFp.destroyResourcePlans(customerId, resourcePlanId, options).then((request) => request(axios, basePath));
    },
    /**
     * 配置計画更新
     * @summary 配置計画更新
     * @param {string} customerId 顧客ID
     * @param {string} resourcePlanId 配置計画ID
     * @param {CreateResourcePlansRequest} [createResourcePlansRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateResourcePlans(
      customerId: string,
      resourcePlanId: string,
      createResourcePlansRequest?: CreateResourcePlansRequest,
      options?: any,
    ): AxiosPromise<ResourcePlan> {
      return localVarFp
        .updateResourcePlans(customerId, resourcePlanId, createResourcePlansRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ResourcePlansApi - object-oriented interface
 * @export
 * @class ResourcePlansApi
 * @extends {BaseAPI}
 */
export class ResourcePlansApi extends BaseAPI {
  /**
   * 配置計画一覧を取得する
   * @summary 配置計画一覧
   * @param {string} customerId 顧客ID
   * @param {string} startDate 開始日
   * @param {string} endDate 終了日
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ResourcePlansApi
   */
  public allResourcePlansByPeriod(customerId: string, startDate: string, endDate: string, options?: AxiosRequestConfig) {
    return ResourcePlansApiFp(this.configuration)
      .allResourcePlansByPeriod(customerId, startDate, endDate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * 配置計画重複チェック
   * @summary 配置計画重複チェック
   * @param {string} customerId 顧客ID
   * @param {CheckOverlapResourcePlansRequest} [checkOverlapResourcePlansRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ResourcePlansApi
   */
  public checkOverlapResourcePlans(
    customerId: string,
    checkOverlapResourcePlansRequest?: CheckOverlapResourcePlansRequest,
    options?: AxiosRequestConfig,
  ) {
    return ResourcePlansApiFp(this.configuration)
      .checkOverlapResourcePlans(customerId, checkOverlapResourcePlansRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * 配置計画重複登録
   * @summary 配置計画重複登録
   * @param {string} customerId 顧客ID
   * @param {CheckOverlapResourcePlansRequest} [checkOverlapResourcePlansRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ResourcePlansApi
   */
  public createOverlapResourcePlans(
    customerId: string,
    checkOverlapResourcePlansRequest?: CheckOverlapResourcePlansRequest,
    options?: AxiosRequestConfig,
  ) {
    return ResourcePlansApiFp(this.configuration)
      .createOverlapResourcePlans(customerId, checkOverlapResourcePlansRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * 配置計画新規登録
   * @summary 配置計画新規登録
   * @param {string} customerId 顧客ID
   * @param {CreateResourcePlansRequest} [createResourcePlansRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ResourcePlansApi
   */
  public createResourcePlans(
    customerId: string,
    createResourcePlansRequest?: CreateResourcePlansRequest,
    options?: AxiosRequestConfig,
  ) {
    return ResourcePlansApiFp(this.configuration)
      .createResourcePlans(customerId, createResourcePlansRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * 配置計画削除
   * @summary 配置計画削除
   * @param {string} customerId 顧客ID
   * @param {string} resourcePlanId 配置計画ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ResourcePlansApi
   */
  public destroyResourcePlans(customerId: string, resourcePlanId: string, options?: AxiosRequestConfig) {
    return ResourcePlansApiFp(this.configuration)
      .destroyResourcePlans(customerId, resourcePlanId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * 配置計画更新
   * @summary 配置計画更新
   * @param {string} customerId 顧客ID
   * @param {string} resourcePlanId 配置計画ID
   * @param {CreateResourcePlansRequest} [createResourcePlansRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ResourcePlansApi
   */
  public updateResourcePlans(
    customerId: string,
    resourcePlanId: string,
    createResourcePlansRequest?: CreateResourcePlansRequest,
    options?: AxiosRequestConfig,
  ) {
    return ResourcePlansApiFp(this.configuration)
      .updateResourcePlans(customerId, resourcePlanId, createResourcePlansRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ResourcesApi - axios parameter creator
 * @export
 */
export const ResourcesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary 特定のリソースの配置計画一覧
     * @param {string} customerId 顧客ID
     * @param {string} resourceId リソースID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allResourcePlansByResource: async (
      customerId: string,
      resourceId: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'customerId' is not null or undefined
      assertParamExists("allResourcePlansByResource", "customerId", customerId);
      // verify required parameter 'resourceId' is not null or undefined
      assertParamExists("allResourcePlansByResource", "resourceId", resourceId);
      const localVarPath = `/{customerId}/api/v2/resources/{resourceId}/resource_plans`
        .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
        .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 指定された期間内に計画がないリソースを取得
     * @param {string} customerId 顧客ID
     * @param {string} startedAt 表示開始時刻 (Unix時間)
     * @param {string} endedAt 表示終了時刻 (Unix時間)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resourcesWithoutPlansInPeriod: async (
      customerId: string,
      startedAt: string,
      endedAt: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'customerId' is not null or undefined
      assertParamExists("resourcesWithoutPlansInPeriod", "customerId", customerId);
      // verify required parameter 'startedAt' is not null or undefined
      assertParamExists("resourcesWithoutPlansInPeriod", "startedAt", startedAt);
      // verify required parameter 'endedAt' is not null or undefined
      assertParamExists("resourcesWithoutPlansInPeriod", "endedAt", endedAt);
      const localVarPath = `/{customerId}/api/v2/resources/resources_without_plans_in_period`.replace(
        `{${"customerId"}}`,
        encodeURIComponent(String(customerId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startedAt !== undefined) {
        localVarQueryParameter["startedAt"] = startedAt;
      }

      if (endedAt !== undefined) {
        localVarQueryParameter["endedAt"] = endedAt;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ResourcesApi - functional programming interface
 * @export
 */
export const ResourcesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ResourcesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary 特定のリソースの配置計画一覧
     * @param {string} customerId 顧客ID
     * @param {string} resourceId リソースID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async allResourcePlansByResource(
      customerId: string,
      resourceId: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ResourcePlan>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.allResourcePlansByResource(customerId, resourceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary 指定された期間内に計画がないリソースを取得
     * @param {string} customerId 顧客ID
     * @param {string} startedAt 表示開始時刻 (Unix時間)
     * @param {string} endedAt 表示終了時刻 (Unix時間)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resourcesWithoutPlansInPeriod(
      customerId: string,
      startedAt: string,
      endedAt: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Resource>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.resourcesWithoutPlansInPeriod(
        customerId,
        startedAt,
        endedAt,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * ResourcesApi - factory interface
 * @export
 */
export const ResourcesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ResourcesApiFp(configuration);
  return {
    /**
     *
     * @summary 特定のリソースの配置計画一覧
     * @param {string} customerId 顧客ID
     * @param {string} resourceId リソースID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allResourcePlansByResource(customerId: string, resourceId: string, options?: any): AxiosPromise<Array<ResourcePlan>> {
      return localVarFp.allResourcePlansByResource(customerId, resourceId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 指定された期間内に計画がないリソースを取得
     * @param {string} customerId 顧客ID
     * @param {string} startedAt 表示開始時刻 (Unix時間)
     * @param {string} endedAt 表示終了時刻 (Unix時間)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resourcesWithoutPlansInPeriod(
      customerId: string,
      startedAt: string,
      endedAt: string,
      options?: any,
    ): AxiosPromise<Array<Resource>> {
      return localVarFp
        .resourcesWithoutPlansInPeriod(customerId, startedAt, endedAt, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ResourcesApi - object-oriented interface
 * @export
 * @class ResourcesApi
 * @extends {BaseAPI}
 */
export class ResourcesApi extends BaseAPI {
  /**
   *
   * @summary 特定のリソースの配置計画一覧
   * @param {string} customerId 顧客ID
   * @param {string} resourceId リソースID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ResourcesApi
   */
  public allResourcePlansByResource(customerId: string, resourceId: string, options?: AxiosRequestConfig) {
    return ResourcesApiFp(this.configuration)
      .allResourcePlansByResource(customerId, resourceId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 指定された期間内に計画がないリソースを取得
   * @param {string} customerId 顧客ID
   * @param {string} startedAt 表示開始時刻 (Unix時間)
   * @param {string} endedAt 表示終了時刻 (Unix時間)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ResourcesApi
   */
  public resourcesWithoutPlansInPeriod(customerId: string, startedAt: string, endedAt: string, options?: AxiosRequestConfig) {
    return ResourcesApiFp(this.configuration)
      .resourcesWithoutPlansInPeriod(customerId, startedAt, endedAt, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RunningTimesApi - axios parameter creator
 * @export
 */
export const RunningTimesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 重機の稼働時間一覧を取得する
     * @summary 稼働時間取得
     * @param {string} heavyMachineId 重機ID
     * @param {number} [from] 取得開始時刻(Unix時間)
     * @param {number} [to] 取得終了時刻(Unix時間)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminAllHeavyMachinesRunningTimes: async (
      heavyMachineId: string,
      from?: number,
      to?: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'heavyMachineId' is not null or undefined
      assertParamExists("adminAllHeavyMachinesRunningTimes", "heavyMachineId", heavyMachineId);
      const localVarPath = `/xBj6IYX7qAnFG6EzwM103qB7MrYuNW/api/v1/heavy_machines/{heavyMachineId}/running_times`.replace(
        `{${"heavyMachineId"}}`,
        encodeURIComponent(String(heavyMachineId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (from !== undefined) {
        localVarQueryParameter["from"] = from;
      }

      if (to !== undefined) {
        localVarQueryParameter["to"] = to;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * リソースの稼働時間一覧を取得する
     * @summary 稼働時間取得
     * @param {string} customerId 顧客ID
     * @param {string} resourceId リソースID
     * @param {number} [from] 取得開始時刻(Unix時間)
     * @param {number} [to] 取得終了時刻(Unix時間)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allResourcesRunningTimes: async (
      customerId: string,
      resourceId: string,
      from?: number,
      to?: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'customerId' is not null or undefined
      assertParamExists("allResourcesRunningTimes", "customerId", customerId);
      // verify required parameter 'resourceId' is not null or undefined
      assertParamExists("allResourcesRunningTimes", "resourceId", resourceId);
      const localVarPath = `/{customerId}/api/v2/resources/{resourceId}/running_times`
        .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
        .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (from !== undefined) {
        localVarQueryParameter["from"] = from;
      }

      if (to !== undefined) {
        localVarQueryParameter["to"] = to;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RunningTimesApi - functional programming interface
 * @export
 */
export const RunningTimesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RunningTimesApiAxiosParamCreator(configuration);
  return {
    /**
     * 重機の稼働時間一覧を取得する
     * @summary 稼働時間取得
     * @param {string} heavyMachineId 重機ID
     * @param {number} [from] 取得開始時刻(Unix時間)
     * @param {number} [to] 取得終了時刻(Unix時間)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminAllHeavyMachinesRunningTimes(
      heavyMachineId: string,
      from?: number,
      to?: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HeavyMachineRunningTime>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.adminAllHeavyMachinesRunningTimes(
        heavyMachineId,
        from,
        to,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * リソースの稼働時間一覧を取得する
     * @summary 稼働時間取得
     * @param {string} customerId 顧客ID
     * @param {string} resourceId リソースID
     * @param {number} [from] 取得開始時刻(Unix時間)
     * @param {number} [to] 取得終了時刻(Unix時間)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async allResourcesRunningTimes(
      customerId: string,
      resourceId: string,
      from?: number,
      to?: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ResourceRunningTime>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.allResourcesRunningTimes(
        customerId,
        resourceId,
        from,
        to,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * RunningTimesApi - factory interface
 * @export
 */
export const RunningTimesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = RunningTimesApiFp(configuration);
  return {
    /**
     * 重機の稼働時間一覧を取得する
     * @summary 稼働時間取得
     * @param {string} heavyMachineId 重機ID
     * @param {number} [from] 取得開始時刻(Unix時間)
     * @param {number} [to] 取得終了時刻(Unix時間)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminAllHeavyMachinesRunningTimes(
      heavyMachineId: string,
      from?: number,
      to?: number,
      options?: any,
    ): AxiosPromise<Array<HeavyMachineRunningTime>> {
      return localVarFp
        .adminAllHeavyMachinesRunningTimes(heavyMachineId, from, to, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * リソースの稼働時間一覧を取得する
     * @summary 稼働時間取得
     * @param {string} customerId 顧客ID
     * @param {string} resourceId リソースID
     * @param {number} [from] 取得開始時刻(Unix時間)
     * @param {number} [to] 取得終了時刻(Unix時間)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allResourcesRunningTimes(
      customerId: string,
      resourceId: string,
      from?: number,
      to?: number,
      options?: any,
    ): AxiosPromise<Array<ResourceRunningTime>> {
      return localVarFp
        .allResourcesRunningTimes(customerId, resourceId, from, to, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RunningTimesApi - object-oriented interface
 * @export
 * @class RunningTimesApi
 * @extends {BaseAPI}
 */
export class RunningTimesApi extends BaseAPI {
  /**
   * 重機の稼働時間一覧を取得する
   * @summary 稼働時間取得
   * @param {string} heavyMachineId 重機ID
   * @param {number} [from] 取得開始時刻(Unix時間)
   * @param {number} [to] 取得終了時刻(Unix時間)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RunningTimesApi
   */
  public adminAllHeavyMachinesRunningTimes(heavyMachineId: string, from?: number, to?: number, options?: AxiosRequestConfig) {
    return RunningTimesApiFp(this.configuration)
      .adminAllHeavyMachinesRunningTimes(heavyMachineId, from, to, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * リソースの稼働時間一覧を取得する
   * @summary 稼働時間取得
   * @param {string} customerId 顧客ID
   * @param {string} resourceId リソースID
   * @param {number} [from] 取得開始時刻(Unix時間)
   * @param {number} [to] 取得終了時刻(Unix時間)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RunningTimesApi
   */
  public allResourcesRunningTimes(
    customerId: string,
    resourceId: string,
    from?: number,
    to?: number,
    options?: AxiosRequestConfig,
  ) {
    return RunningTimesApiFp(this.configuration)
      .allResourcesRunningTimes(customerId, resourceId, from, to, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * SitesApi - axios parameter creator
 * @export
 */
export const SitesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 現場一覧を取得する
     * @summary 現場一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminAllSites: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/xBj6IYX7qAnFG6EzwM103qB7MrYuNW/api/v1/sites`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 現場一覧を取得する
     * @summary 現場一覧
     * @param {string} customerId 顧客ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allSites: async (customerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'customerId' is not null or undefined
      assertParamExists("allSites", "customerId", customerId);
      const localVarPath = `/{customerId}/api/v1/sites`.replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 指定した開始日・終了日の期間に工期が重なっている現場を取得する
     * @summary 現場の取得
     * @param {string} customerId 顧客ID
     * @param {string} startDate 開始日
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sitesByConstructionPeriod: async (
      customerId: string,
      startDate: string,
      endDate?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'customerId' is not null or undefined
      assertParamExists("sitesByConstructionPeriod", "customerId", customerId);
      // verify required parameter 'startDate' is not null or undefined
      assertParamExists("sitesByConstructionPeriod", "startDate", startDate);
      const localVarPath = `/{customerId}/api/v2/sites`.replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startDate !== undefined) {
        localVarQueryParameter["startDate"] = startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter["endDate"] = endDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SitesApi - functional programming interface
 * @export
 */
export const SitesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SitesApiAxiosParamCreator(configuration);
  return {
    /**
     * 現場一覧を取得する
     * @summary 現場一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminAllSites(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Site>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.adminAllSites(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * 現場一覧を取得する
     * @summary 現場一覧
     * @param {string} customerId 顧客ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async allSites(
      customerId: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Site>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.allSites(customerId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * 指定した開始日・終了日の期間に工期が重なっている現場を取得する
     * @summary 現場の取得
     * @param {string} customerId 顧客ID
     * @param {string} startDate 開始日
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sitesByConstructionPeriod(
      customerId: string,
      startDate: string,
      endDate?: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SiteWithSchedule>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sitesByConstructionPeriod(
        customerId,
        startDate,
        endDate,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * SitesApi - factory interface
 * @export
 */
export const SitesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = SitesApiFp(configuration);
  return {
    /**
     * 現場一覧を取得する
     * @summary 現場一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminAllSites(options?: any): AxiosPromise<Array<Site>> {
      return localVarFp.adminAllSites(options).then((request) => request(axios, basePath));
    },
    /**
     * 現場一覧を取得する
     * @summary 現場一覧
     * @param {string} customerId 顧客ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allSites(customerId: string, options?: any): AxiosPromise<Array<Site>> {
      return localVarFp.allSites(customerId, options).then((request) => request(axios, basePath));
    },
    /**
     * 指定した開始日・終了日の期間に工期が重なっている現場を取得する
     * @summary 現場の取得
     * @param {string} customerId 顧客ID
     * @param {string} startDate 開始日
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sitesByConstructionPeriod(
      customerId: string,
      startDate: string,
      endDate?: string,
      options?: any,
    ): AxiosPromise<Array<SiteWithSchedule>> {
      return localVarFp
        .sitesByConstructionPeriod(customerId, startDate, endDate, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * SitesApi - object-oriented interface
 * @export
 * @class SitesApi
 * @extends {BaseAPI}
 */
export class SitesApi extends BaseAPI {
  /**
   * 現場一覧を取得する
   * @summary 現場一覧
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SitesApi
   */
  public adminAllSites(options?: AxiosRequestConfig) {
    return SitesApiFp(this.configuration)
      .adminAllSites(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * 現場一覧を取得する
   * @summary 現場一覧
   * @param {string} customerId 顧客ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SitesApi
   */
  public allSites(customerId: string, options?: AxiosRequestConfig) {
    return SitesApiFp(this.configuration)
      .allSites(customerId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * 指定した開始日・終了日の期間に工期が重なっている現場を取得する
   * @summary 現場の取得
   * @param {string} customerId 顧客ID
   * @param {string} startDate 開始日
   * @param {string} [endDate]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SitesApi
   */
  public sitesByConstructionPeriod(customerId: string, startDate: string, endDate?: string, options?: AxiosRequestConfig) {
    return SitesApiFp(this.configuration)
      .sitesByConstructionPeriod(customerId, startDate, endDate, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
